import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";

import {
  MatButtonModule,
  MatCardModule,
  MatCheckboxModule,
  MatDatepickerModule,
  MatExpansionModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatPaginatorModule,
  MatSelectModule,
  MatSlideToggleModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatTooltipModule,
  MatAutocompleteModule,
  MatRadioModule
} from "@angular/material";

import { FlexLayoutModule } from "@angular/flex-layout";
import { StoreModule } from "@ngrx/store";

import { FormEditorComponent } from "./components/form-editor/form-editor.component";
import { FormListComponent } from "./components/form-list/form-list.component";

import { FormDataFieldsComponent } from "./components/form-data-fields/form-data-fields.component";
import { FormService } from "./services/form.service";
import { SelectFieldOptionsService } from "./services/select-field-options-service.service";
import { SelectFieldOptionsEditComponent } from "./components/select-field-options-edit/select-field-options-edit.component";
import { IndentPipe } from "app/core/commons/utils/indent.pipe";
import { reducers } from "./state/reducers";
import { FormDataListComponent } from "./components/form-data-list/form-data-list.component";
import { SelectFieldOptionsListComponent } from "./components/select-field-options-list/select-field-options-list.component";
import { EffectsModule } from "@ngrx/effects";
import { SubformEffects } from "./state/subform.effects";
import { SelectFieldOptionsEffects } from "./state/select-field-options.effects";
import { FormEditorEffects } from "./state/form-editor.effects";
import { FXDirectiveModule } from "../directives/fx.directive";
import { ConfirmDialogModule } from "primeng/primeng";
import { FormDataComponent } from "./components/form-data/form-data.component";
import { FormDataService } from "./services/form-data.service";
import { FormDataResolveService } from "./services/form-data-resolve.service";
import { FormDataViewComponent } from "./components/form-data-view/form-data-view.component";
import {FillableTextComponent} from "./components/form-data-fillable-text/fillable-text.component";
import {FillableTextFieldComponent} from "./components/form-data-fillable-text-field/fillable-text-field.component";
import {FillableTextEditorComponent} from "./components/fillable-text-editor/fillable-text-editor.component";
import {CoreModule} from "../core/core.module";
import {ImagePickerDialog} from "./components/image-picker-dialog/image-picker-dialog.component";
import {MatDialogModule} from "@angular/material/dialog";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    FXDirectiveModule,
    FlexLayoutModule,
    MatCardModule,
    MatExpansionModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatTooltipModule,
    MatListModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatTableModule,
    MatPaginatorModule,
    MatSortModule,
    MatAutocompleteModule,
    MatRadioModule,
    ConfirmDialogModule,
    MatDialogModule,
    CoreModule,
    StoreModule.forFeature("forms", reducers),
    EffectsModule.forFeature([
      SubformEffects,
      SelectFieldOptionsEffects,
      FormEditorEffects
    ])
  ],
  providers: [FormService, FormDataService, SelectFieldOptionsService],
  declarations: [
    FormEditorComponent,
    FormListComponent,
    FormDataFieldsComponent,
    SelectFieldOptionsEditComponent,
    IndentPipe,
    FillableTextComponent,
    FormDataListComponent,
    SelectFieldOptionsListComponent,
    FormDataComponent,
    FormDataViewComponent,
    FillableTextFieldComponent,
    FillableTextEditorComponent,
    ImagePickerDialog
  ],
    entryComponents: [ImagePickerDialog]
})
export class DynFormsModule {}



// WEBPACK FOOTER //
// ./src/app/forms/dyn-forms.module.ts